import { m } from 'framer-motion';
import { fadeIn } from '../../../Litho/Functions/GlobalAnimations';
import { Col, Container, Row } from 'react-bootstrap';
import { Element } from 'react-scroll';
import IconWithText from '../../../Litho/Components/IconWithText/IconWithText';

const data = [
	{
		title: 'Your Intercontinental Shipping Solutions',
		content:
			'Your enhanced supply chain solution will accelrate your business while also driving efficiency.',
		icon: 'fa fa-globe-europe text-3xl bg-red-100 text-[#bd3531] p-2 rounded',
	},
	{
		title: 'Secure, transparent, and reliable',
		content:
			'Check and trackevery logistic in your pocket. Your logistic is safe, you can sleep without worry anymore',
		icon: 'fa fa-key text-3xl bg-[#fae4d4] text-[#eb7e2b] p-2 rounded',
	},
	{
		title: 'Easy to use and manage',
		content:
			'Our platform is easy to use and manage. You can track your logistic in real-time and get the latest update.',
		icon: 'fa solid-icon-Security-Check text-3xl bg-[#d4f5d4] text-[#28a745] p-2 rounded',
	},
];

const AboutUsSection = () => {
	return (
		<Element name='activities'>
			<m.section
				className='overflow-x-hidden py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px]'
				{...fadeIn}
			>
				<Container>
					<Row className='flex-row items-center justify-between'>
						<Col lg={6} xs={12}>
							<div>
								<span className='text-tprimary'>About</span>
								<h3 className='text-ttertiary font-calistoga'>
									Solutions for your
									<br />
									business need
								</h3>
							</div>
						</Col>
						<Col lg={6} xs={12}>
							<p>
								We make logistics shiping much easier and straightforward.
								Combining good services and technology make everything
								efficient.
							</p>
						</Col>
					</Row>
					<div
						className='
          grid notMobile:grid-cols-3 gap-4
          mt-16 notMobile:flex-row'
					>
						{data?.map((item, index) => (
							<m.section
								key={index}
								className='bg-gray-100 bg-opacity-50 rounded-2xl'
								{...fadeIn}
							>
								<IconWithText
									grid='row-cols-1 justify-center gap-5 sm:gap-3'
									theme='icon-with-text-03'
									data={[item]}
								/>
							</m.section>
						))}
					</div>
				</Container>
			</m.section>
		</Element>
	);
};

export default AboutUsSection;
